import {IntermediatePart} from "../../intermediatePart";

export default class BottomCabinetLeg extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'bottom_cabinet_leg';
    this.partName = 'Bottom Cabinet Leg';
    this.translateId = "visualizer.kitchen.cabinet.bottom_cabinet_leg";
    this.canBeDisabled = true;
  }

}
